import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70e1c0c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = { class: "header-actions" }

import IconBase from '@/components/Icons/IconBase.vue'
import CircleButton from '@/components/Buttons/CircleButton.vue'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseHeader',
  setup(__props) {

const router = useRouter()

const authStore = useAuthStore()
const isAuth = computed(() => authStore.isAuth)


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "header-content__logo"
    }, {
      default: _withCtx(() => [
        _createVNode(IconBase, {
          name: "logo",
          width: 80,
          height: 15,
          "view-box": "0 0 80 15"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createVNode(CircleButton, {
            bg: "theme",
            name: "home",
            iconWidth: 16,
            iconHeight: 18,
            "view-box": "0 0 16 18"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: {name: 'profile'} }, {
        default: _withCtx(() => [
          _createVNode(CircleButton, {
            bg: isAuth.value ? 'gradient' : 'theme',
            name: "profile",
            iconWidth: 16,
            iconHeight: 18,
            "view-box": "0 0 16 18"
          }, null, 8, ["bg"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})